import { styled } from '@mui/material'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .highcharts-credits,
  .highcharts-legend-item {
    display: none !important;
  }

  .highcharts-xaxis-labels text:first-of-type,
  .highcharts-xaxis-labels text:last-of-type {
    opacity: 1;
  }
`

export const Root = styled('div')`
  width: 100%;
`
